<template>
  <div>
    <div id="cont" class="container">
      <div class="row">
        <div class="col-12">
          <b-nav
              id="nav">
            <a href="#/">
              <b-img
                  :src="logoImg"
                  alt="Emu"
                  id="logo"></b-img>
            </a>
            <a href="#/assist">
              <b-img
                  :src="assistImg"
                  alt="Assist"
                  id="assist"
              ></b-img>
            </a>
            <a href="#/assist">
              <h4 id="assist_label">智能助手</h4>
            </a>
            <div class="ml-auto" id="breadcrumb">
              <small class="bc-divider">当前位置：</small>
              <a class="bc-divider">健康管理</a>
              <small class="bc-divider"> > </small>
              <a class="bc-active">接种概况</a>
            </div>
          </b-nav>
        </div>
      </div>
      <div class="row">
        <div id="sidebar" class="col-md-4">
          <side-bar></side-bar>
        </div>
        <div id="content" class="col-md-8">
          <div id="bar">
            <div id="complete"
                 @mousedown="$router.push('/complete')"
                 @mouseover="percentage.complete='(50%)'" @mouseout="percentage.complete=''">
              <p class="label">已接种 {{ percentage.complete }}</p>
            </div>
            <div id="suggest"
                 @mousedown="$router.push('/suggest')"
                 @mouseover="percentage.suggest='(30%)'" @mouseout="percentage.suggest=''">
              <p class="label">建议接种 {{ percentage.suggest }}</p>
            </div>
            <div id="incomplete"
                 @mousedown="$router.push('/incomplete')"
                 @mouseover="percentage.incomplete='(20%)'" @mouseout="percentage.incomplete=''">
              <p class="label">未接种 {{ percentage.incomplete }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "../common";
import SideBar from "@/components/SideBar";

export default {
  name: "Overview",
  components: {SideBar},
  data() {
    return {
      logoImg: common.logoImgSrc,
      assistImg: common.assistImgSrc,
      percentage: {
        complete: "",
        suggest: "",
        incomplete: "",
      }
    }
  },
  mounted() {
    common.assureLogin(this);
  }
}
</script>

<style>
body {
  background: #f5f5f5 !important;
}
</style>

<style scoped src="../main.css"/>
vh
<style scoped>
#content {
  position: relative;
}

#bar {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 7.5%;
  background: white;
  height: 70px;
  width: 85%;
  border-radius: 35px;
  box-shadow: 2px 2px 10px 2px #ddd;
}

#complete {
  position: absolute;
  background: lightseagreen;
  left: 5px;
  top: 5px;
  height: 60px;
  border-radius: 30px 0 0 30px;
  width: calc((100% - 10px) * 0.5);
  transition: top 0.2s ease, left 0.2s ease, height 0.2s ease, width 0.2s ease;
}

#complete:hover {
  top: 0;
  left: 0;
  height: 70px;
  width: calc((100% - 10px) * 0.5 + 5px);
  border-radius: 35px 0 0 35px;
  transition: top 0.2s ease, left 0.2s ease, height 0.2s ease, width 0.2s ease;
}

#suggest {
  position: absolute;
  background: khaki;
  left: calc((100% - 10px) * 0.5 + 5px);
  top: 5px;
  height: 60px;
  width: calc((100% - 10px) * 0.3);
}

#suggest:hover {
  top: 0;
  height: 70px;
  transition: top 0.2s ease, height 0.2s ease;
}

#incomplete {
  position: absolute;
  background: indianred;
  left: calc((100% - 10px) * 0.8 + 4px);
  top: 5px;
  height: 60px;
  border-radius: 0 30px 30px 0;
  width: calc((100% - 10px) * 0.2);
}

#incomplete:hover {
  top: 0;
  height: 70px;
  border-radius: 0 35px 35px 0;
  width: calc((100% - 10px) * 0.2 + 5px);
  transition: top 0.2s ease, height 0.2s ease, width 0.2s ease;
}

.label {
  color: white;
  font-weight: bold;
  text-align: center;
  line-height: 60px;
}
</style>